import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { COMPANY } from "../lib/constants";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About Us" },
  { to: "/services", label: "Services" },
  { to: "/projects", label: "Projects" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const linkCls = ({ isActive }) =>
    `text-sm font-semibold transition-colors hover:text-brand-green ${
      isActive ? "text-brand-green" : "text-brand-ink/70"
    }`;

  return (
    <header data-testid="main-nav" className="sticky top-0 z-50 border-b border-brand-green/10 bg-white/90 backdrop-blur-md">
      <div className="mx-auto flex h-[76px] max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Logo />
        <nav className="hidden items-center gap-8 lg:flex" aria-label="Main navigation">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`} className={linkCls} end={l.to === "/"}>
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden items-center gap-4 lg:flex">
          <a
            href={`tel:${COMPANY.phone}`}
            data-testid="nav-phone-link"
            className="flex items-center gap-2 text-sm font-bold text-brand-green transition-colors hover:text-brand-green2"
          >
            <Phone className="h-4 w-4" strokeWidth={2.4} />
            {COMPANY.phoneDisplay}
          </a>
          <Link
            to="/contact"
            data-testid="nav-quote-btn"
            className="rounded-full bg-brand-red px-6 py-2.5 text-sm font-bold text-white shadow-md transition-all hover:bg-brand-redDark hover:shadow-lg active:scale-95"
          >
            Get a Free Quote
          </Link>
        </div>
        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="rounded-lg p-2 text-brand-green lg:hidden"
          aria-label={open ? "Close menu" : "Open menu"}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <div data-testid="mobile-menu" className="border-t border-brand-light bg-white px-4 pb-6 pt-3 lg:hidden">
          <nav className="flex flex-col gap-1" aria-label="Mobile navigation">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className={({ isActive }) =>
                  `rounded-lg px-3 py-3 text-base font-semibold ${
                    isActive ? "bg-brand-light text-brand-green" : "text-brand-ink/75"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
          <div className="mt-4 flex flex-col gap-3">
            <a href={`tel:${COMPANY.phone}`} data-testid="mobile-call-btn" className="flex items-center justify-center gap-2 rounded-full border-2 border-brand-green py-3 text-sm font-bold text-brand-green">
              <Phone className="h-4 w-4" /> Call {COMPANY.phoneDisplay}
            </a>
            <Link to="/contact" onClick={() => setOpen(false)} data-testid="mobile-quote-btn" className="rounded-full bg-brand-red py-3 text-center text-sm font-bold text-white">
              Get a Free Quote
            </Link>
          </div>
        </div>
      )}
      <span className="sr-only">{location.pathname}</span>
    </header>
  );
};
